/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The coarse, user-facing status shown to everyone. Most users see only this summary, not the
 * ten-value internal Compliance.Module.Support.Enums.SupportDevelopmentStatus — a reporter cares that their
 * ticket is being worked on, not whether it is "On UAT" versus "In Test".
 *
 * Support users see both: the summary plus the real development status.
 */
export enum SupportSummaryStatus {
    DRAFT = 'Draft',
    NEW = 'New',
    STARTED = 'Started',
    COMPLETE = 'Complete',
    CANCELLED = 'Cancelled',
}
